<template>
  <div class="container">
    <div class="row mb-5 d-flex justify-content-center">
      <div
        class="col-10 col-md-8 border rounded align-items-center justify-content-between p-3"
      >
        <div class="row">
          <div class="col-6">
            <h5 class="text-nowrap font-weight-bold m-0">
              Carnival {{ new Date().getFullYear() }} Information
            </h5>
          </div>
          <div class="col-6 text-right">
            <b-spinner
              style="width: 17px; height: 17px"
              v-if="fetching"
              class="mr-2"
              small
            ></b-spinner>
            <icon-vue
              v-b-toggle.evtInfo
              :icon="['far', 'edit']"
              class="pointer"
            ></icon-vue>
          </div>
          <b-collapse visible ref="collapse" class="mt-3 col-12" id="evtInfo">
            <hr />
            <div>
              <b-form @submit.prevent="updateData(dbRefs.eventRef, event)">
                <b-form-group id="grp-name" label="Name" label-for="input-name">
                  <b-form-input
                    id="input-name"
                    placeholder="Leicester Caribbean Carnival"
                    v-model="event.name"
                  ></b-form-input>
                </b-form-group>
                <b-form-group id="grp-date" label="Date" label-for="input-date">
                  <b-form-input
                    id="input-subtitle"
                    type="date"
                    v-model="event.date"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="grp-gatesOpen"
                  label="Gates Open Time"
                  label-for="input-gatesOpen"
                >
                  <b-form-input
                    id="input-gatesOpen"
                    v-model="event.gatesOpen"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="grp-venue"
                  label="Venue"
                  label-for="input-venue"
                >
                  <b-form-input
                    id="input-venue"
                    v-model="event.venue"
                  ></b-form-input>
                </b-form-group>
                <b-form-group id="grp-city" label="City" label-for="input-city">
                  <b-form-input
                    id="input-city"
                    v-model="event.city"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="grp-postalCode"
                  label="Postal Code"
                  label-for="input-postalCode"
                >
                  <b-form-input
                    id="input-postalCode"
                    v-model="event.postalCode"
                  ></b-form-input>
                </b-form-group>
                <b-button
                  class="btn-carnival px-5 py-1"
                  type="submit"
                  variant="outline-success"
                  :disabled="saving"
                >
                  Save
                </b-button>
              </b-form>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../eventBus';
import AddDataHandler from '../../mixins/genericAddDataHandler';
import DataStreamListener from '../../mixins/dataListener';
import { mapState } from 'vuex';
import { defaultEvent } from '../../utils/content';

export default {
  data() {
    return {
      event: { ...defaultEvent },
    };
  },
  mixins: [AddDataHandler, DataStreamListener],
  methods: {},
  async mounted() {
    this.fetchSingleData(this.dbRefs.eventRef, defaultEvent);
    EventBus.$on('dataFetched', (event) => {
      this.event = event;
      setTimeout(() => {
        this.fetching = false;
      }, 1000);
    });
  },
};
</script>
